import { render, staticRenderFns } from "./couponCode.vue?vue&type=template&id=057164ef&scoped=true&lang=pug"
import script from "./couponCode.vue?vue&type=script&lang=js"
export * from "./couponCode.vue?vue&type=script&lang=js"
import style0 from "./couponCode.vue?vue&type=style&index=0&id=057164ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "057164ef",
  null
  
)

export default component.exports